import React from 'react'
import WarehousesList from './list'

const Warehouses = () => {
    return (
        <>
            <WarehousesList/>
        </>

    )
}

export default Warehouses